import React from 'react';
import Container from './Container';
import Title from './Title';
import ItemDetailsContainer from './ItemDetailsContainer';
import ItemTitle from './ItemTitle';
import ItemDescription from './ItemDescription';
import ItemImage from './ItemImage';
import ItemImageContainer from './ItemImageContainer';
import ItemDetailsHeader from './ItemDetailsHeader';
import ItemDiscount from './ItemDiscount';
import ItemDetailsBody from './ItemDetailsBody';
import ItemLink from './ItemLink';
import commercePropTypes from '../../prop-types/commercePropTypes';

var AdsBanner = function AdsBanner(_ref) {
  var storeName = _ref.storeName,
      adsItems = _ref.adsItems,
      adsImageHeight = _ref.adsImageHeight,
      adsImageWidth = _ref.adsImageWidth,
      adsImageTransformation = _ref.adsImageTransformation,
      orientation = _ref.orientation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, adsItems.map(function (ad, index) {
    var title = ad.title,
        collectionTitle = ad.collectionTitle,
        shortDescription = ad.shortDescription,
        image = ad.image,
        discount = ad.discount,
        url = ad.url;
    var transformImage = image.replace('q_auto,f_auto', adsImageTransformation);
    return /*#__PURE__*/React.createElement(ItemLink, {
      href: url,
      key: index,
      target: "_blank",
      orientation: orientation
    }, /*#__PURE__*/React.createElement(Container, {
      orientation: orientation
    }, /*#__PURE__*/React.createElement(ItemImageContainer, {
      $height: adsImageHeight,
      $width: adsImageWidth
    }, /*#__PURE__*/React.createElement(ItemImage, {
      image: transformImage,
      height: adsImageHeight,
      width: adsImageWidth,
      alt: title
    })), /*#__PURE__*/React.createElement(ItemDetailsContainer, null, /*#__PURE__*/React.createElement(ItemDetailsHeader, null, /*#__PURE__*/React.createElement(Title, null, storeName), /*#__PURE__*/React.createElement(ItemDiscount, {
      discount: discount
    })), /*#__PURE__*/React.createElement(ItemDetailsBody, null, /*#__PURE__*/React.createElement(ItemTitle, null, collectionTitle), /*#__PURE__*/React.createElement(ItemDescription, null, shortDescription)))));
  }));
};

AdsBanner.defaultProps = {
  storeName: undefined,
  adsImageHeight: undefined,
  adsImageWidth: undefined,
  orientation: 'landscape'
};
export default AdsBanner;